export function generateThemeVars(primaryColor: string): string {
  return `
    --mcp-primary: ${primaryColor};
    --mcp-primary-hover: ${adjustBrightness(primaryColor, -15)};
    --mcp-primary-light: ${adjustBrightness(primaryColor, 40)};
    --mcp-bg: #ffffff;
    --mcp-bg-secondary: #f8fafc;
    --mcp-text: #1a202c;
    --mcp-text-secondary: #6b7280;
    --mcp-border: #e5e7eb;
    --mcp-radius: 12px;
    --mcp-radius-sm: 6px;
    --mcp-shadow: 0 10px 40px rgba(0, 0, 0, 0.12);
    --mcp-font: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Helvetica Neue', Arial, sans-serif;
    --mcp-font-size: 14px;
    --mcp-transition: 0.2s ease;
    --mcp-z-index: 2147483647;
  `;
}

function adjustBrightness(hex: string, percent: number): string {
  const clean = hex.replace('#', '');
  const num = parseInt(clean, 16);
  const r = Math.min(255, Math.max(0, (num >> 16) + Math.round(2.55 * percent)));
  const g = Math.min(255, Math.max(0, ((num >> 8) & 0x00ff) + Math.round(2.55 * percent)));
  const b = Math.min(255, Math.max(0, (num & 0x0000ff) + Math.round(2.55 * percent)));
  return `#${((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1)}`;
}
